module.exports = __webpack_public_path__ + "img/java_light_natural_ba_list.57223151.jpg";